import React, { useEffect, useState } from "react"
import { Button } from "../../../ui/button"
import { ArrowDownIcon } from "lucide-react"
import AOS from "aos"
import "aos/dist/aos.css"
import TeamModal from "./team-modal";
import { useIsMobile } from "../../../hooks/use-mobile"

const HeroSection = () => {
  const [isTeamModalOpen, setIsTeamModalOpen] = useState(false)
  const isMobile = useIsMobile()

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-out"
    })
  }, [])

  const scrollToJobs = () => {
    const jobsSection = document.getElementById("jobs")
    if (jobsSection) {
      jobsSection.scrollIntoView({ behavior: "smooth" })
    }
  }

  const openTeamModal = () => {
    setIsTeamModalOpen(true)
  }

  return (
    <section className="relative min-h-[100vh] w-full flex items-center justify-center overflow-hidden">
      {/* Background image with better mobile handling */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
          backgroundPosition: isMobile ? "65% center" : "center"
        }}
      />

      {/* Dark purple overlay for contrast */}
      <div className="absolute inset-0 bg-[rgba(92,41,136,0.6)] z-10"></div>

      <div className="container mx-auto px-4 sm:px-6 relative z-20 text-center py-16 md:py-0">
        <div className="max-w-3xl mx-auto">
          <h1
            className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 md:mb-5 leading-tight text-white"
            data-aos="fade-up"
          >
            Join the <span className="text-[#FFDDEF]">most creative minds</span>{" "}
            building the future
          </h1>
          <p
            className="text-sm sm:text-base md:text-xl lg:text-2xl mb-6 sm:mb-8 text-white max-w-2xl mx-auto"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            At Oye Creator, we're not just colleagues—we're a family of
            dreamers, builders, and problem solvers changing how creators and
            enterprises connect.
          </p>
          <div
            className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-4 sm:mt-6"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <Button
              onClick={scrollToJobs}
              className="bg-oye-pink hover:bg-oye-pink/90 text-white px-4 sm:px-6 md:px-8 py-2.5 sm:py-3 md:py-4 lg:py-5 rounded-lg sm:rounded-xl lg:rounded-2xl text-sm sm:text-base lg:text-lg flex items-center justify-center gap-2 w-full sm:w-auto"
            >
              See open roles
              <ArrowDownIcon size={18} />
            </Button>
            <Button
              variant="outline"
              className="border-2 border-solid border-white text-white bg-[rgba(255,255,255,0.1)] hover:bg-white/20 px-4 sm:px-6 md:px-8 py-2.5 sm:py-3 md:py-4 lg:py-5 rounded-lg sm:rounded-xl lg:rounded-2xl text-sm sm:text-base lg:text-lg w-full sm:w-auto"
              onClick={openTeamModal}
            >
              Meet our team
            </Button>
          </div>
        </div>
      </div>

      <TeamModal
        isOpen={isTeamModalOpen}
        onClose={() => setIsTeamModalOpen(false)}
      />
    </section>
  )
}

export default HeroSection
